import { render, staticRenderFns } from "./ViewAuditRecruitment.vue?vue&type=template&id=bc965aba&scoped=true"
import script from "./ViewAuditRecruitment.vue?vue&type=script&lang=js"
export * from "./ViewAuditRecruitment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc965aba",
  null
  
)

export default component.exports